<template>
    <button
        type="button"
        class="tw:inline-flex tw:items-center tw:justify-center tw:px-3 tw:py-2 tw:border tw:border-gray-300
               tw:leading-6 tw:rounded-md tw:shadow-xs tw:hover:bg-gray-200"
    >
        <span
            v-show="showSpinner"
            class="tw:mr-3 tw:flex tw:items-center tw:justify-center"
        >
            <span
                class="tw:w-8 tw:h-8 tw:border-4 tw:border-dotted tw:border-hiorg-blau-400 tw:border-t-transparent
                       tw:rounded-full tw:animate-spin"
            />
        </span>
        {{ text }}
    </button>
</template>

<script setup lang="ts">
defineProps<{
    text: string;
    showSpinner: boolean;
}>();
</script>
